<template>
  <div>
    <div class="houselist">
      <div class="houselist-t">
        <div class="houselist-t-1">温馨提示</div>
        <div class="houselist-t-2"></div>
      </div>
      <div style="font-size:14px;color:#777">
        为有效提高房屋租售信息的规范化，避免重复发布房屋租售信息，房产频道采用收费发布；
        <span style="color:#ff0000;">咨询电话：023-73372998</span>
      </div>
    </div>

    <div class="blank"></div>
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell clickable>
            <van-radio slot="right-icon" :name="1" checked-color="#07c160" />
            <div slot="title">
              有效期2个月：
              <font color="#ff5722">￥38</font>
            </div>
          </van-cell>
        <van-cell clickable>
          <van-radio slot="right-icon" :name="2" checked-color="#07c160" />
          <div slot="title">
            有效期3个月：
            <font color="#ff5722">￥48</font>
          </div>
        </van-cell>
       
          <van-cell clickable>
            <van-radio slot="right-icon" :name="3" checked-color="#07c160" />
            <div slot="title">
              有效期6个月：
              <font color="#ff5722">￥78</font>
            </div>
          </van-cell>

      </van-cell-group>
    </van-radio-group>
    <div class="blank"></div>
    <div class="houselist">
      <div class="houselist-t">
        <div class="houselist-t-1">支付</div>
        <div class="houselist-t-2"></div>
      </div>
    </div>
    <van-cell clickable>
      <div slot="title" style="display:flex; align-items: center;">
        <van-icon name="chat" color="#07c160" />微信支付
      </div>
      <van-checkbox slot="right-icon" checked-color="#07c160" v-model="checked" />
    </van-cell>

    <div class="tijiao">
      <div class="tijiao-txt">
        支付金额
        <span>￥{{ postpay1 }}</span>
      </div>
      <div class="tijiao-btn">
        <van-button color="#f56229" @click="order">提交订单</van-button>
      </div>
    </div>
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Footbar from "../commpents/footbar";
import Usertop from "../commpents/usertop";
import {
  Checkbox,
  CheckboxGroup,
  Card,
  Toast,
  Cell,
  CellGroup,
  Button,
  Icon,
  Row,
  Tag,
  List,
  Col,
  NavBar,
  RadioGroup,
  Radio,
  SubmitBar,
  Dialog
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [List.name]: List,
    [NavBar.name]: NavBar,
    [RadioGroup.name]: RadioGroup,
    [SubmitBar.name]: SubmitBar,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    Footbar,
    Usertop
  },

  data() {
    return {
      getInitUrl: root + "order/init",
      getOrderUrl: root + "order/save",
      getSaveUrl: root + "order/agent",
      radio: 1,
      toppays: [],
      checked: true,
      id: 0,
      pay: 0,
      user: [],
      beizhu: "",
      refer: "",
      model: {},
      json: {}
    };
  },
  computed: {
    postpay1() {
      if (this.radio == 1) {
        return 38;
      } else if (this.radio == 2) {
        return 48;
      } else if (this.radio == 3) {
        return 78;
      } else {
        return 38;
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    this.beizhu = this.$route.params.type;
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: {
          type: self.beizhu,
          cid: self.id
        },
        headers: self.getRequestHeader(),
        success: function (reponseData, status) {
          //self.postpay1 = reponseData.pay;
        },
        error: function () {
          self.$toast("system error");
        }
      });
    },
    order() {
      var self = this;
      if (self.postpay1 > 0) {
        $.ajax({
          url: self.getOrderUrl,
          timeout: 120000,
          dataType: "json",
          type: "get",
          data: {
            type: "pay",
            money: self.postpay1,
            cid: self.id,
            beizhu: self.beizhu
          },
          headers: self.getRequestHeader(),
          success: function (reponseData, status) {
            // self.$toast(reponseData.message);
            //self.$router.push("/zhifu/" + reponseData.orderid);
            //location.href = "https://adn.45win.com/html/?#/zhifu/" + reponseData.orderid;
            self.model = reponseData.model;
            self.refer = reponseData.refer;
            self.json = reponseData.json;
            self.zhifu();
          },
          error: function () {
            self.$toast("system error");
          }
        });
      }
    },
    zhifu() {
      var self = this;
      if (self.refer == "qianfan") {
        QFH5.getUserInfo(function (state, data) {
          if (state == 1) {
            var json = {
              type: 10039,
              item: [
                {
                  title: "石柱生活网房产频道",
                  subtitle: "订单号：" + self.model.orderid,
                  cover: "",
                  num: 1,
                  // cash_cost: 0,
                  cash_cost: self.model.money,
                  // gold_cost: self.model.money,
                  get_expire: 0
                }
              ],
              send_type: 0,
              send_cost: 0,
              allow_change_address: 1,
              address: {
                name: "",
                mobile: "",
                address: ""
              },
              allow_pay_type: 14,
              allow_pay_time: 900,
              out_trade_no: self.model.orderid,
              ext: self.orderid
            };

            QFH5.Order(JSON.stringify(json), function (state, data) {
              if (state == 1) {
                QFH5.jumpPayOrder(data.order_id, function (state, data) {
                  if (state == 1) {
                    self.$toast("支付成功!");
                    self.$router.push("/" + self.beizhu + "/view/" + self.id);
                  } else {
                    self.$toast("支付失败!");
                  }
                });
              }
            });
          } else {
            self.$toast("请登录app");
          }
        });
      } else if (self.refer == "wechat") {
        // self.$router.push("/zhifu/" + self.model.id);
        location.href = "http://adn.45win.com/html/?#/zhifu/" + self.model.id;
      } else {
        self.$toast("没有支付方式");
      }
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}

.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar-img img {
  width: 80%;
}

.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar-info h1 {
  font-size: 18px;
}

.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}

.user-tag {
  text-align: center;
  padding: 15px 0;
}

.user-tag img {
  width: 40px;
}

.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}

.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.tijiao {
  height: 60px;
  display: flex;
  justify-content: space-between;

  align-items: center;
  position: fixed;
  bottom: 10px;
  width: 100%;
}

.tijiao-txt {
  margin: 0 20px;
  font-size: 14px;
  color: #777;
}

.tijiao-txt span {
  color: #ee0a24;
  font-size: 16px;
}

.tijiao-btn {
  margin: 0 20px;
}
</style>>
